<template>
    <div>
    </div>
</template>
 
<script>

    export default {
        data() {
            return {
                orderNo: "",
                confirmAction: "",
                checkCount: 0
            };
        },
        computed: {
            info() {
                return this.$root.info;
            },
            cart() {
                return this.$root.cart;
            },
        },
        components: { },
        created() {
            this.info.loading = true;
            this.orderNo = this.$root.getParameterByName("orderNo");
            this.confirmAction = this.$root.getParameterByName("confirmAction");
            this.checkMemberLogin();
        },
        destroyed() {
            this.$root.setGoBackAction();
        },
        methods: {
            checkMemberLogin() {
                console.log("checkMemberLogin");
                var app = this;
                app.checkCount++;
                if (app.cart.member != null) {
                    app.checkCount = 1000;
                    app.$router.replace("/confirmation?orderNo=" + encodeURIComponent(app.orderNo) + "&confirmAction=" + encodeURIComponent(app.confirmAction));
                }
                else {
                    if (this.checkCount <= 100) {
                        window.setTimeout(function () {
                            app.checkMemberLogin();
                        }, 1000);
                    }
                    else {
                        app.$router.replace("/");
                    }
                }
            }

        },
    };
</script>

